import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { getLocalDateStrFromDate, getLocalTimeStrFromDate } from '../../utils/time';

function ConfirmationModal(props: {
    showConfirmationModal: any,
    setShowConfirmationModal: any,
    confirmTime: Date,
}) {

    const handleClose = () => props.setShowConfirmationModal(false);
    const handleOpen = () => {
        window.open(`/ops?date=${props.confirmTime.getTime()}`, '_blank');
    }

    return (
        <>
            <Modal show={props.showConfirmationModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Point-in-Time View</Modal.Title>
                </Modal.Header>
                <Modal.Body>Navigating to this view will open a new window that show you what the ED looked like at {getLocalDateStrFromDate(props.confirmTime)} {getLocalTimeStrFromDate(props.confirmTime)} (local time)</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleOpen}>
                        Open <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ConfirmationModal;
